// extracted by mini-css-extract-plugin
export default {"promowrap":"AN","promo":"BN","ship":"CN","pause":"EN","happy":"FN","promotext":"GN"};
    if(module.hot) {
      // 1738064243574
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  